import React from 'react';
import styled from 'styled-components';

const GlowFC = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: className
  });
};

const Glow = styled(GlowFC)`
  background: ${props => props.color};
  mix-blend-mode: screen;
  opacity: 0.7;
  transform: translate3d(0, 0, 0);
  filter: blur(78px);
`;
export default Glow;